<template>
   <Head>
      <title>{{ $t("meta.privacy.title") }}</title>
      <meta name="description" :content="$t('meta.privacy.content')" />
   </Head>

   <ClientOnly>
      <PageLoader :isLoading="isLoading" :loadErrors="loadErrors">
         <main class="container mx-auto px-4 pt-20">
            <div v-if="pageContent" data-cy="privacy-container" class="text-base leading-normal">
               <h1 class="h2 mb-8 text-brand-dark">{{ pageContent.heading }}</h1>
               <PageSections v-if="pageContent.sections?.length" :contentSections="pageContent.sections" />
            </div>
         </main>
      </PageLoader>
   </ClientOnly>
</template>

<script setup lang="ts">
import { Head } from "@unhead/vue/components";
import ContentApi, { type PageContent } from "@/data/api-layer/contentApi";
import { useApiRequest } from "@/composables/useApiRequest";

const { isLoading, execRequest, loadErrors } = useApiRequest();
const { t: $t } = useI18n();
const pageContent = ref<PageContent>(null);

onMounted(async () => {
   const response = await execRequest(() => ContentApi.getPrivacy());
   if (!response) return;

   pageContent.value = response.content;
});
</script>

<style scoped></style>
